import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const LEFT_CARDS = [{
  id: 1,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/qnxDRMgijBWbxj7cXreA3W/Image_(44).jpg',
  caption: 'Signature Drinks'
}, {
  id: 2,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/ntShQdakv6KbGyf9Jx4jwG/image.png',
  caption: 'Signature Drinks'
}, {
  id: 3,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/3rQeNX4y13rPu7dn8mtDSF/IMG_3430.jpg',
  caption: 'Signature Drinks'
}];
const RIGHT_CARDS = [{
  id: 1,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/3f6hFJTyZ6arXDyyajUZh7/image.png',
  caption: 'Desserts'
}, {
  id: 2,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/fXfSUGZpYr5EWNohLVRjDt/image.png',
  caption: 'Desserts'
}, {
  id: 3,
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/3KzRr8tUfUx3Zc8J4wjnFR/ChatGPT_Image_Jun_17,_2026,_06_02_59_PM.png',
  caption: 'Desserts'
}];
export function Hero() {
  const [leftCards, setLeftCards] = useState(LEFT_CARDS);
  const [rightCards, setRightCards] = useState(RIGHT_CARDS);
  useEffect(() => {
    const timer = setInterval(() => {
      setLeftCards(prev => {
        const newCards = [...prev];
        const frontCard = newCards.pop();
        if (frontCard) newCards.unshift(frontCard);
        return newCards;
      });
      setRightCards(prev => {
        const newCards = [...prev];
        const frontCard = newCards.pop();
        if (frontCard) newCards.unshift(frontCard);
        return newCards;
      });
    }, 2000);
    return () => clearInterval(timer);
  }, []);
  return <section className="relative w-full min-h-[90vh] bg-black flex flex-col items-center justify-center pt-12 overflow-hidden font-montserrat" data-id="element-80">
      {/* Main Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-81">
        <img src="https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b?auto=format&fit=crop&q=80&w=2070" alt="Cocktails background" className="w-full h-full object-cover opacity-40" data-id="element-82" />
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-20 pb-10 flex flex-col items-center gap-16" data-id="element-83">
        <div className="w-full flex flex-col md:flex-row items-center justify-between gap-12" data-id="element-84">
          {/* Left Polaroid Stack */}
          <div className="relative w-72 h-96 hidden lg:block perspective-1000" data-id="element-85">
            <AnimatePresence mode="popLayout" data-id="element-86">
              {leftCards.map((card, index) => {
              const isFront = index === leftCards.length - 1;
              const isBack = index === leftCards.length - 2;
              const isHidden = index < leftCards.length - 2;
              return <motion.div key={card.id} layout initial={false} animate={{
                scale: isFront ? 1 : isBack ? 0.85 : 0.8,
                rotate: isFront ? -2 : isBack ? 12 : 0,
                x: isFront ? 0 : isBack ? 60 : 0,
                y: isFront ? 0 : isBack ? -30 : 0,
                opacity: isHidden ? 0 : 1,
                zIndex: index
              }} transition={{
                duration: 0.8,
                type: 'spring',
                bounce: 0.5
              }} className="absolute top-0 left-0 bg-white p-3 pb-12 shadow-2xl origin-bottom-right" style={{
                pointerEvents: isFront ? 'auto' : 'none'
              }} data-id="element-87">
                    <div className="w-64 h-80 overflow-hidden relative bg-gray-100" data-id="element-88">
                      {card.type === 'video' ? <video src={card.src} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-89" /> : <img src={card.src} alt={card.caption} className="w-full h-full object-cover" data-id="element-90" />}
                    </div>
                    <p className="font-dancing text-2xl text-gray-800 mt-4 text-center" data-id="element-91">
                      {card.caption}
                    </p>
                  </motion.div>;
            })}
            </AnimatePresence>
          </div>

          {/* Center Text */}
          <div className="text-center flex-1 flex flex-col items-center font-montserrat" data-id="element-92">
            <h1 className="font-dancing text-6xl md:text-8xl text-[#992f74] leading-tight drop-shadow-lg" data-id="element-93">
              Sips & <br data-id="element-94" />
              <span className="text-white" data-id="element-95">Nibblez</span>
            </h1>
            <p className="font-dancing text-3xl md:text-4xl text-white mt-4 italic mb-10" data-id="element-96">
              Premium Cocktails, Mocktails, and Gourmet Bites
            </p>
            <motion.a href="/book" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block bg-[#992f74] text-white px-10 py-4 text-sm font-bold tracking-widest uppercase hover:bg-white hover:text-[#992f74] transition-colors duration-300 shadow-xl font-montserrat" data-id="element-97">
              Book Your Experience
            </motion.a>
          </div>

          {/* Right Polaroid Stack */}
          <div className="relative w-72 h-80 hidden lg:block perspective-1000" data-id="element-98">
            <AnimatePresence mode="popLayout" data-id="element-99">
              {rightCards.map((card, index) => {
              const isFront = index === rightCards.length - 1;
              const isBack = index === rightCards.length - 2;
              const isHidden = index < rightCards.length - 2;
              return <motion.div key={card.id} layout initial={false} animate={{
                scale: isFront ? 1 : isBack ? 0.85 : 0.8,
                rotate: isFront ? 3 : isBack ? -10 : 0,
                x: isFront ? 0 : isBack ? -50 : 0,
                y: isFront ? 0 : isBack ? -25 : 0,
                opacity: isHidden ? 0 : 1,
                zIndex: index
              }} transition={{
                duration: 0.8,
                type: 'spring',
                bounce: 0.5
              }} className="absolute top-0 right-0 bg-white p-3 pb-12 shadow-2xl origin-bottom-left" style={{
                pointerEvents: isFront ? 'auto' : 'none'
              }} data-id="element-100">
                    <div className="w-64 h-64 overflow-hidden relative bg-gray-100" data-id="element-101">
                      {card.type === 'video' ? <video src={card.src} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-102" /> : <img src={card.src} alt={card.caption} className="w-full h-full object-cover" data-id="element-103" />}
                    </div>
                    <p className="font-dancing text-2xl text-gray-800 mt-4 text-center" data-id="element-104">
                      {card.caption}
                    </p>
                  </motion.div>;
            })}
            </AnimatePresence>
          </div>
        </div>
      </div>

      {/* Torn Paper Bottom Edge */}
      <div className="absolute bottom-0 left-0 w-full z-20 pointer-events-none" data-id="element-105">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto" data-id="element-106">
          <path d="M0 120H1440V45.5L1412 55.5L1380 35.5L1345 65.5L1310 45.5L1275 75.5L1240 55.5L1205 85.5L1170 65.5L1135 95.5L1100 75.5L1065 105.5L1030 85.5L995 115.5L960 95.5L925 125.5L890 105.5L855 135.5L820 115.5L785 145.5L750 125.5L715 155.5L680 135.5L645 165.5L610 145.5L575 175.5L540 155.5L505 185.5L470 165.5L435 195.5L400 175.5L365 205.5L330 185.5L295 215.5L260 195.5L225 225.5L190 205.5L155 235.5L120 215.5L85 245.5L50 225.5L20 255.5L0 245.5V120Z" fill="black" data-id="element-107" />
          <path d="M0 120H1440V45.5L1412 55.5L1380 35.5L1345 65.5L1310 45.5L1275 75.5L1240 55.5L1205 85.5L1170 65.5L1135 95.5L1100 75.5L1065 105.5L1030 85.5L995 115.5L960 95.5L925 125.5L890 105.5L855 135.5L820 115.5L785 145.5L750 125.5L715 155.5L680 135.5L645 165.5L610 145.5L575 175.5L540 155.5L505 185.5L470 165.5L435 195.5L400 175.5L365 205.5L330 185.5L295 215.5L260 195.5L225 225.5L190 205.5L155 235.5L120 215.5L85 245.5L50 225.5L20 255.5L0 245.5V120Z" fill="black" transform="translate(0, -10)" opacity="0.5" data-id="element-108" />
        </svg>
      </div>
    </section>;
}